import { render, staticRenderFns } from "./SignAgreement.vue?vue&type=template&id=a99b70aa&scoped=true"
import script from "./SignAgreement.vue?vue&type=script&lang=js"
export * from "./SignAgreement.vue?vue&type=script&lang=js"
import style0 from "./SignAgreement.vue?vue&type=style&index=0&id=a99b70aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b70aa",
  null
  
)

export default component.exports